module.exports = "/static/pdf/SG-Merchant-Contract.82b668abc98a71fa2488f93abbbca68d.pdf";